import padStart from "lodash/padStart";
const getHashFromString = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
};
export const generateColorFromString = (str) => {
    const hash = getHashFromString(str);
    let color = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += padStart(value.toString(16), 2, "0");
    }
    return color;
};
export const getColorByString = (colors, str) => {
    if (colors.length === 0)
        throw new Error("getColorByString массив не содержит цветов");
    const hash = getHashFromString(str);
    const index = Math.abs(hash) % colors.length;
    return colors[index];
};
